import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserService } from './user.service';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class DeleteTypesService {

  constructor(private userService: UserService, private environmentService: EnvironmentService) { }

  deleteType(path){
    console.log('path', path);
    let deleted = new Subject();
    let details = path.split(/\//g);
    console.log('details', details);
    let type = details[1];
    let id = details[2];
    console.log('type', type, 'id', id);
    if(type === 'users'){
      this.deleteUser(id).subscribe((data) => {
        deleted.next(data);
        deleted.complete();
      });
    }else{
      //delay to simulate api call
      setTimeout(() => {
        deleted.next('No such type');
        deleted.complete();
      }, 100);
    }
    return deleted.asObservable();
  }

  deleteUser(id){
    console.log('id', id);
    let deleted = new Subject();
    this.userService.getUser(id).subscribe((user: any) => {
      if(!user?.data?.cognito_username){
        deleted.next('No such user');
        deleted.complete();        
      } else{     
      this.environmentService.getInstanceDetails().subscribe((instanceData) => {
        let proms = [];
        instanceData.instances.forEach(instance => {
          let promise = new Promise((resolve, reject) => {
            this.userService.getUserByCognito(user.data.cognito_username, instance.sub_domain, instance.environment).subscribe(
              (data: any) => {
                console.log('data', data);
                if (data.id && data.id !== id) {
                  console.log('deleting user data', data.id, instance.sub_domain, instance.environment);
                  this.userService.deleteUserData(data.id, instance.sub_domain, instance.environment).subscribe((res) => {
                    resolve(res);
                  });
                } else {
                  resolve(data);
                }
              }
            );
          });
          proms.push(promise);
        })
        Promise.all(proms).then((data) => {
          deleted.next(data);
          deleted.complete();
        });
      });
      }

    })
    return deleted.asObservable();
  }
}
